<template>
    laat ons uw locatie-data zien gast
</template>

<script>

export default {
    name: 'AllowGeolocationView'
}
</script>